import { executiveQuickActions } from './dashboard.data';

export const ExecutiveQuickActions = () => (
  <section aria-labelledby="arx-dashboard-actions-title">
    <div className="arx-executive-section-heading">
      <div>
        <span>ACESSO DIRETO</span>
        <h2 id="arx-dashboard-actions-title">Ações rápidas</h2>
      </div>
      <p>Atalhos para os principais recursos operacionais do portal.</p>
    </div>

    <div className="arx-executive-actions">
      {executiveQuickActions.map(item => (
        <a className="arx-executive-action" href={item.href} key={item.id}>
          <div>
            <strong>{item.label}</strong>
            <p>{item.description}</p>
          </div>
          <span aria-hidden="true">→</span>
        </a>
      ))}
    </div>
  </section>
);
